import {helpers} from 'vuelidate/lib/validators';

/**
 * Validator for ID values to match pattern defined in API.
 */
export default helpers.withParams({type: 'resourceId'}, (value) => {
    // by default consider the ID is optional
    if (helpers.req(value)) {
        return helpers.regex('resourceId', /^[@~\-.\w\d]{1,50}$/)(value);
    }
    return true;
});
